var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      ref: "modal",
      attrs: { size: _vm.size },
      on: {
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _c("h4", { attrs: { slot: "modal-title" }, slot: "modal-title" }, [
        _vm.icon ? _c("i", { class: _vm.icon }) : _vm._e(),
        _vm._v(" " + _vm._s(_vm.title) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "modal-body" }, slot: "modal-body" },
        [
          _vm._t("body", [
            _c("p", [
              _vm._v("\n                " + _vm._s(_vm.body) + "\n            ")
            ])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row align-content-end",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer"
        },
        _vm._l(_vm.buttons, function(button) {
          return _c(
            "div",
            {
              key: button.name + "-" + _vm.guid(),
              staticClass: "col-auto d-flex flex-column"
            },
            [
              _c(
                "button",
                {
                  staticClass: "mt-auto",
                  class: button.class || "",
                  on: {
                    click: function($event) {
                      return _vm.emitChoice(button.emit)
                    }
                  }
                },
                [
                  button.icon ? _c("i", { class: button.icon }) : _vm._e(),
                  _vm._v(" " + _vm._s(button.name || "") + "\n             ")
                ]
              )
            ]
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }